import { Box, styled } from "@mui/material";

export const TaskChips = styled(Box)(() => ({
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
})) as typeof Box;
